import React, { useEffect, useState } from 'react'
import $ from 'jquery';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as sharedActions from '../../Actions/sharedActions';
import SnackBar from '../../components/SnackBar/SnackBar';
import SelectionInput from '../../components/SelectionInput/SelectionInput';
import TextInput from '../../components/TextInput/TextInput'
import Pagination from '../../components/Pagination/Pagination'
import Spinner from '../../components/Spinner/Spinner';
import httpWithRequiredSetData from '../../hooks/Services/httpWithRequiredSetData';
import general from '../../utils/general'
import Colors from '../../utils/app_constants/colors_constants';
import CustomFilterSectionLayout from '../../components/CustomFilterSectionLayout/CustomFilterSectionLayout';

let tHead = [
    'Name',
    'Class Applied To',
    'For Session',
    'Actions'
];

let renderFields = [
    'name',
    'className',
    'session',
]

const AssignClassNewAdmits = props => {

    const [classId, setClassId] = useState('');
    const [sectionId, setSectionId] = useState('');
    const [sessionId, setSessionId] = useState('')
    const [name, setName] = useState('')
    const [className, setClassName] = useState('')
    const [session, setSession] = useState('')
    const [modalData, setModalData] = useState([])
    const [accountType, setAccountType] = useState(props.role)
    const [accountId, setAccountId] = useState(props.name)
    const [postSessionId, setPostSessionId] = useState('')
    const [postClassId, setPostClassId] = useState('')
    const [studentId, setStudentId] = useState('')

    const [classData, setClassData] = useState([]);
    const [sectionData, setSectionData] = useState([]);
    const [sessionData, setSessionData] = useState([]);
    const [admissionData, setAdmissionData] = useState([]);

    const [isClassSectionLoading, classSectionData] = httpWithRequiredSetData(
        '/api/ClassesSections',
        [],
        data => {
            setClassData(data['classes']);
        }
    );

    const [isSessionLoading, sessions] = httpWithRequiredSetData(
        '/api/session',
        [],
        data => {
            setSessionData(data['session']);
        }
    );

    const [searchURL, setSearchURL] = useState(
        '/api/ListOfAdmissions?pageNumber=&pageSize=10&classId=&sessionId=&name='
    );


    const [disableBPage, setdisableBPage] = useState(true);
    const [customPageSize, setCustomPageSize] = useState('10');
    const [currentPage, setCurrentPage] = useState(1);
    const [pageNumber, setPageNumber] = useState([]);
    const [disablepage, setdisablepage] = useState(false);
    const [pagination, setPaginationData] = useState({});


    const [
        isLoading,
        fetchData,
        setFetchData,
        setIsLoading
    ] = httpWithRequiredSetData(searchURL, [], data => {
        let pageNumber = [];
        for (let i = 1; i <= data['paginationMetadata']['totalPages']; i++) {
            pageNumber.push(i);
        }
        setPageNumber(pageNumber);
        setAdmissionData(data['admissionList']);

        setPaginationData(data['paginationMetadata']);
    });

    const onClassChange = inputClassId => {
        setSectionId('');
        if (inputClassId !== 'Choose Class') {

            setIsLoading(true);
            setClassId(inputClassId);
        }
    };

    const onHandleChange = e => {
        if (e.target.name === 'name') {
            setName(e.target.value)
        } else if (e.target.name === 'sessionId') {
            setSessionId(e.target.value)
        } else if (e.target.name === 'sectionId') {
            if (e.target.value !== 'Section') {
                setSectionId(e.target.value);
            }
        }
    }

    useEffect(() => {
        return () => {
            $('[data-toggle="tooltip"]').tooltip('hide');
        };
    }, []);

    const handleClickNextFrwd = () => {
        console.log('pagelength: ', pageNumber.length);
        console.log('current page: ', currentPage);
        if (currentPage === pageNumber.length) {
            setdisablepage(true);
        } else {
            setCurrentPage(prevState => prevState + 1);
            console.log(currentPage);

            setdisableBPage(false);
        }
    };

    useEffect(() => {
        console.log('Do something after counter has changed', currentPage);
        setIsLoading(true);
        props.sharedActions
            .getDataWithoutDispatch(
                general.condtionalServicesNewAdmit(
                    classId,
                    sessionId,
                    name,
                    currentPage,
                    customPageSize
                )
            )
            .then(success => {
                setAdmissionData(success['admissionList']);
                setIsLoading(false);
                let pageNumber = [];
                for (let i = 1; i <= success['paginationMetadata']['totalPages']; i++) {
                    pageNumber.push(i);
                }
                setPageNumber(pageNumber);
                setPaginationData(success['paginationMetadata']);
            })
            .catch(error => {
                setIsLoading(false);
                setAdmissionData([])
                setPaginationData({})
            });
    }, [currentPage, classId, sessionId, name, customPageSize]);
    const handleClickNext = event => {
        setCurrentPage(Number(event.target.id));
        setdisableBPage(false);
        setdisableBPage(false);
    };
    const handleClickNextBack = () => {
        if (currentPage === 1) {
            setdisableBPage(true);
            setdisablepage(false);
        } else {
            setCurrentPage(prevState => prevState - 1);
        }
    };
    const [msg, setSnackMsg] = useState('');

    const onChangePageSize = e => {
        if (e.target.value !== 'Page Entries') {
            setCustomPageSize(e.target.value);
            setCurrentPage(1);
        }
    };

    const onTakeItem = (itemId) => {
        setModalData([])

        let getData = admissionData.filter(item => item.studentAdmissionFormId === itemId);

        setModalData(getData)
        setClassName(getData[0].className)
        setSession(getData[0].session)
        setPostSessionId(getData[0].sessionId)
        setPostClassId(getData[0].classId)
        setStudentId(getData[0].studentAdmissionFormId)

        let getSection = general.dataFilteration(
            classSectionData['gradeSection'],
            ['sectionId', 'section'],
            {
                id: getData[0].classId
            }
        );

        setSectionData(getSection)
    }

    const onEditClick = itemId => {
        onTakeItem(itemId)
    }

    const AssignClass = e => {
        e.preventDefault();

        if (sectionId !== '') {
            const data = {
                studentId,
                classId: postClassId,
                sectionId,
                sessionId: postSessionId,
                accountId,
                accountType
            }
            props.sharedActions
                .simpleAddRequest('/api/AssignClassToAdmissionStudent/',
                    data)
                .then(success => {
                    setSnackMsg('Assigned Class Successfully!')
                    setStudentId('')
                    setSectionId('')
                    setSectionData([])
                    setPostClassId('')
                    setPostSessionId('')
                    setModalData([])
                    let getNewFilterArray = admissionData.filter(item => item.studentAdmissionFormId !== studentId);
                    setAdmissionData(getNewFilterArray)
                    $('#myModal').modal('toggle'); //or  $('#IDModal').modal('hide');
                    props.snackbar();
                })
                .catch(error => { })
        }
    }

    const bodyRendering = data =>
        data &&
        data.map((item, index) => (
            <tr>
                <th
                    style={{
                        padding: 2,
                        border: `1px solid ${Colors.SEA_GREEN_THEME}`,
                        borderColor: Colors.SEA_GREEN_THEME
                    }}
                    scope="row"
                >
                    {index + 1}
                </th>
                {renderFields.map((item1, index) => (
                    <td
                        style={{
                            fontWeight: `${index == 0 ? 'bold' : 'normal'}`,
                            border: `1px solid ${Colors.SEA_GREEN_THEME}`,
                            padding: 2,
                            borderColor: Colors.SEA_GREEN_THEME
                        }}
                    >
                        {item[item1]}
                    </td>
                ))}
                <td
                    style={{
                        border: `1px solid ${Colors.SEA_GREEN_THEME}`,
                        padding: 2,
                        borderColor: Colors.SEA_GREEN_THEME
                    }}
                >
                    <a href="#" data-toggle="tooltip" title="Assign Class To Student!">
                        <button
                            id="firstbutton"
                            onClick={() => onEditClick(item.studentAdmissionFormId)}
                            data-toggle="modal"
                            data-target="#myModal"
                            style={{
                                cursor: 'pointer',
                                fontSize: 20,
                                border: 'none',
                                marginLeft: 5,
                                background: 'none',
                                marginBottom: 5
                            }}
                        >
                            <i style={{ color: '#01AC8A' }} class="fas fa-user-plus"></i>
                        </button>
                    </a>
                </td>
            </tr>
        ));

    return (
        <div>
            <SnackBar msg={msg} />
            <div class="modal" id="myModal">
                <div class="modal-dialog">
                    <div class="modal-content modal_content_custom">
                        <div
                            style={{
                                borderBottomLeftRadius: 30,
                                borderBottomRightRadius: 30,
                                borderTopLeftRadius: 18,
                                borderTopRightRadius: 18
                            }}
                            class="modal-header modal_custom_header"
                        >
                            <h4 style={{ color: 'white' }} class="modal-title">
                                Assign Class To Student!
								</h4>
                            <button
                                style={{ color: 'white' }}
                                type="button"
                                class="close"
                                data-dismiss="modal"
                            >
                                &times;
								</button>
                        </div>
                        <div class="modal-body">
                            <form >
                                {modalData &&
                                    modalData.map((item, index) => (
                                        <div key={index}>
                                            <fieldset>
                                                <div class='row'>

                                                    <TextInput
                                                        feildName={'className'}
                                                        inputLabelName={'Class Name'}
                                                        errors={{}}
                                                        stateData={{
                                                            className: className
                                                        }}
                                                        placeholder="Class Name"
                                                        readOnly={true}
                                                        type={'text'}
                                                        isValidte={false}
                                                    />

                                                    <TextInput
                                                        feildName={'session'}
                                                        inputLabelName={'Session'}
                                                        errors={{}}
                                                        stateData={{ session: session }}
                                                        placeholder="Session"
                                                        readOnly={true}
                                                        type={'text'}
                                                        isValidte={false}
                                                    />
                                                    <SelectionInput
                                                        feildName={'sectionId'}
                                                        selectName={'Section'}
                                                        onHandleChange={e => onHandleChange(e)}
                                                        errors={{}}
                                                        optionsArrys={sectionData}
                                                        selectedText={'Section'}
                                                        stateData={{
                                                            sectionId: sectionId
                                                        }}
                                                        // iconClassName={'fas fa-building'}
                                                        optionType="dynamicWithPropIdAndName"
                                                        property={'section'}
                                                        propertyId={'sectionId'}
                                                        isValidte={false}
                                                    // editUse={'staffEdit'}
                                                    />

                                                </div>
                                            </fieldset>
                                            <br />
                                        </div>
                                    ))}
                            </form>
                        </div>
                        <div class="modal-footer">
                            <button
                                type="button"
                                style={{ background: '#00435D' }}
                                class="btn btn-danger"
                                onClick={e => AssignClass(e)}
                            >
                                Post
								</button>
                        </div>
                    </div>
                </div>
            </div>
            <div style={{ textAlign: 'right' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <div>
                        <h2 className="h1-responsive font-weight-bold text-left my-4 generalHead">
                            {' '}
                            Student Coordinator{' '}
                        </h2>
                    </div>
                    <div
                        style={{ marginTop: 40, display: 'flex', flexDirection: 'column' }}
                    >
                        <Pagination
                            disableBPage={disableBPage}
                            disablepage={disablepage}
                            currentPage={currentPage}
                            pageNumber={pageNumber}
                            handleClickNext={handleClickNext}
                            handleClickNextBack={handleClickNextBack}
                            handleClickNextFrwd={handleClickNextFrwd}
                        />
                        <div
                            style={{
                                width: 'fit-content',
                                marginTop: -34,
                                display: 'flex',
                                justifyContent: 'flex-end',
                                marginLeft: 'auto'
                            }}
                        >
                            <SelectionInput
                                selectName="Entries"
                                selectFont={14}
                                selectFontWeight={'bold'}
                                newFlag="customWidth"
                                feildName="customPageSize"
                                selectedText={'Page Entries'}
                                optionsArrys={['10', '20', '30', '40', '50']}
                                errors={{}}
                                isValidte={false}
                                stateData={{
                                    customPageSize: customPageSize
                                }}
                                optionType="static"
                                onHandleChange={onChangePageSize}
                                useFlag={false}
                            />
                        </div>
                    </div>
                </div>
                <CustomFilterSectionLayout displayDirection="column">
                    <div
                        style={{
                            width: '40%',
                            margin: '0 auto',
                            display: 'flex',
                            justifyContent: 'center'
                        }}
                    >
                        <React.Fragment>
                            <SelectionInput
                                newFlag="customWidth"
                                feildName="classId"
                                selectName={'Class'}
                                selectedText={'Choose Class'}
                                optionsArrys={classData}
                                errors={{}}
                                isValidte={false}
                                stateData={{
                                    classId: classId
                                }}
                                optionType="dynamic"
                                onHandleChange={e => onClassChange(e.target.value)}
                                property={'className'}
                                propertyId={'id'}
                                useFlag={false}
                            />
                            <SelectionInput
                                newFlag="customWidth"
                                useFlag={false}
                                feildName={'sessionId'}
                                selectName={'Session'}
                                onHandleChange={e => onHandleChange(e)}
                                errors={{}}
                                optionsArrys={sessionData}
                                selectedText={'Session'}
                                stateData={{
                                    sessionId: sessionId
                                }}
                                // iconClassName={'fas fa-building'}
                                optionType="dynamicWithPropIdAndName"
                                property={'currentSession'}
                                propertyId={'sessionId'}
                                isValidte={false}
                            // editUse={'staffEdit'}
                            />
                            <TextInput
                                feildName={'name'}
                                inputLabelName={'Applicant Name'}
                                onHandleChange={e => onHandleChange(e)}
                                errors={{}}
                                stateData={{
                                    name: name
                                }}
                                placeholder={'Applicant Name'}
                                isValidte={false}
                                newFlag="customWidth"
                                useFlag={false}
                            />
                        </React.Fragment>
                    </div>
                </CustomFilterSectionLayout>

                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <span className="customBadge" style={{ fontSize: 14 }}>
                        Page: {currentPage}
                    </span>

                    <span className="customBadge" style={{ fontSize: 14 }}>
                        Total Page: {pagination['totalPages']}
                    </span>
                </div>
            </div>
            {isLoading ? (
                <Spinner />
            ) :
                admissionData.length < 1 ? <div style={{ display: 'flex', justifyContent: 'center', color: 'red' }}>
                    <strong>No Data</strong>
                </div>
                    : (
                        <div className="table-responsive">
                            <table class="table table-hover">
                                <thead style={{ background: '#01AC8A', color: 'white' }}>
                                    <tr>
                                        <th scope="col">#</th>
                                        {tHead.map(item => (
                                            <th
                                                style={{
                                                    border: `1px solid ${Colors.SEA_GREEN_THEME}`,
                                                    borderColor: Colors.WHITE
                                                }}
                                                scope="col"
                                            >
                                                {item}
                                            </th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>{bodyRendering(admissionData)}</tbody>
                            </table>
                        </div>
                    )}
        </div>
    );
};

function mapStateToProps(state) {
    return {
        role: state.setUserReducer.users.role,
        name: state.setUserReducer.users.unique_name,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        sharedActions: bindActionCreators(sharedActions, dispatch)
    };
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AssignClassNewAdmits);